export default function createMenuPayloadFromEditable(data) {
  if (!data) return null;

  return {
    translations: data.translations,
    url: data.url || '',
    icon: data.icon || '',
    is_enabled: Boolean(data.isEnabled),
    menu_item_id: data.menuItemId,
  };
}
